import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [//路由配置
    {// 主页
      path     : '/',
      name     : 'Home',
      component: () => import('../views/Home/Home.vue')
    },
    {// 导航
      path     : '/nav',
      name     : 'nav',
      component: () => import('../views/nav/nav.vue')
    },
    {// 导航1
      path     : '/one',
      name     : 'one',
      component: () => import('../views/page/one.vue')
    },
    {// 导航2
      path     : '/two',
      name     : 'two',
      component: () => import('../views/page/two.vue')
    },
    {// 导航3
      path     : '/thr',
      name     : 'thr',
      component: () => import('../views/page/thr.vue')
    },
    {// 导航4
      path     : '/fou',
      name     : 'fou',
      component: () => import('../views/page/fou.vue')
    },
    {// 导航5
      path     : '/fiv',
      name     : 'fiv',
      component: () => import('../views/page/fiv.vue')
    },
    {// 导航6
      path     : '/six',
      name     : 'six',
      component: () => import('../views/page/six.vue')
    },
    {// 导航7
      path     : '/sev',
      name     : 'sev',
      component: () => import('../views/page/sev.vue')
    },
    {// 导航的知识点链接
      path     : '/navKnowledge',
      name     : 'navKnowledge',
      component: () => import('../views/knowledge/navKnowledge.vue')
    },
    {// 第二个页 面知识点链接
      path     : '/twoKnowledge',
      name     : 'twoKnowledge',
      component: () => import('../views/knowledge/twoKnowledge.vue')
    },
    {// 第三个页 面知识点链接
      path     : '/thrKnowledge',
      name     : 'thrKnowledge',
      component: () => import('../views/knowledge/thrKnowledge.vue')
    },
    {// 第四个页 面知识点链接
      path     : '/fouKnowledge',
      name     : 'fouKnowledge',
      component: () => import('../views/knowledge/fouKnowledge.vue')
    },
    // {// 3d测试
    //   path     : '/3d',
    //   name     : '3d',
    //   component: () => import('../../waste/3d/3d.vue')
    // },
]

const router = new VueRouter({
  // 路由模式
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
